import Immutable, { List, Map } from 'immutable';
import { OrgDateTime } from '../../Root';
import { DateTime } from 'luxon';
import { appActionTypes } from '../../shared/stores/app_actionTypes';

// Action Types
const SET_SELECTED_EQUIPMENT = 'dashboard/SET_SELECTED_EQUIPMENT';
const SET_DATE_RANGE = 'dashboard/SET_DATE_RANGE';
const SET_TAB_SELECTED = 'dashboard/SET_TAB_SELECTED';
const SET_IS_LOADING = 'dashboard/SET_IS_LOADING';
const SET_SUMMARY_DATA = 'dashboard/SET_SUMMARY_DATA';
const SET_CUSTOM_MODAL_OPEN = 'dashboard/SET_CUSTOM_MODAL_OPEN';
const SET_INITIAL_DASHBOARD_SETTINGS = 'dashboard/SET_INITIAL_DASHBOARD_SETTINGS';
const SET_UPDATE_BACKEND = 'dashboard/SET_UPDATE_BACKEND';

// Action Creators
export const setSelectedEquipment = (eqObj) => ({
    type: SET_SELECTED_EQUIPMENT,
    eqObj,
});

export const setDateRange = (dateRange, dateUpdate=true) => ({
    type: SET_DATE_RANGE,
    dateRange,
    dateUpdate
});

export const setTabSelected = (tabSelected) => ({
    type: SET_TAB_SELECTED,
    tabSelected,
});

export const setIsLoading = (isLoading) => ({
    type: SET_IS_LOADING,
    isLoading,
});

export const setSummaryData = (summaryData) => ({
    type: SET_SUMMARY_DATA,
    summaryData,
});

export const setCustomModalOpen = (isOpen) => ({
    type: SET_CUSTOM_MODAL_OPEN,
    isOpen,
});

export const setInitialDashboardSettings = (settings) => ({
    type: SET_INITIAL_DASHBOARD_SETTINGS,
    settings,
});

export const setUpdateBackend = (updateBackend) => ({
    type: SET_UPDATE_BACKEND,
    updateBackend,
});

// Initial State
const initialState = Immutable.fromJS({
    selectedEquipment: {},
    dateRange: {
        dates: ['', ''],
        dropdownValue: 'mtd',
    },
    tabSelected: 'usage',
    summaryData: {
        tableData: [],
        graphData: {},
    },
    isCustomModalOpen: false,
    isLoading: true,
    updateBackend: false,
});

// Reducer
const dashboardReducer = (state = initialState, action) => {
    switch(action.type) {

        case appActionTypes["app/changeUserOrg"]:
            return initialState;
            
        case SET_SELECTED_EQUIPMENT:
            return state
                .set('selectedEquipment', Immutable.fromJS(action.eqObj))
                .set('updateBackend', true);

        case SET_DATE_RANGE:
            return state
                .set('dateRange', Immutable.fromJS(action.dateRange))
                .set('updateBackend', action.dateUpdate);

        case SET_TAB_SELECTED:
            return state
                .set('tabSelected', action.tabSelected)
                .set('updateBackend', true);

        case SET_IS_LOADING:
            return state.set('isLoading', action.isLoading);

        case SET_SUMMARY_DATA:
            return state.set('summaryData', Immutable.fromJS(action.summaryData));

        case SET_CUSTOM_MODAL_OPEN:
            return state.set('isCustomModalOpen', action.isOpen);

        case SET_INITIAL_DASHBOARD_SETTINGS: {
            const settings = action.settings;
            const dropdownValue = settings.getIn(
                ['dateRange', 'dropdownValue'], 'today'
            );
            
        let [stopDate, startDate] = OrgDateTime.getDatesFromRange(
            dropdownValue,
            [],
            false,
            true
        );
            // let _dateRange = settings.get(
            //     'dateRange',
            //     Immutable.fromJS({ dates: ['', ''], dropdownValue: 'mtd' })
            // )
            let _dateRange = Immutable.fromJS({
                dates: [startDate, stopDate],
                dropdownValue: dropdownValue
            })
            if (dropdownValue === 'custom'){
                const datesArray = settings.getIn(['dateRange', 'dates'], List([]));
                const updatedDatesArray = datesArray.map(date => DateTime.fromISO(date));
                _dateRange = _dateRange.set('dates', updatedDatesArray);
            }
            let eq = settings.get('selectedEquipment', Map({}));
            eq = Map.isMap(eq) ? eq : Map({});
            return state
                .set('selectedEquipment', eq)
                .set('dateRange', _dateRange)
                .set('tabSelected', settings.get('tabSelected', 'usage'))
                .set('isLoading', false);
        }

        case SET_UPDATE_BACKEND:
            return state.set('updateBackend', action.updateBackend);

        default:
            return state;
    }
};

export default dashboardReducer;
